import User from "@/Models/User";
import {onUnmounted, ref} from "vue";

type EchoEvent = {
    event: string;
    callback: (e: any) => void | Promise<void>;
};

export default (events: EchoEvent[] = []) => {
    const $echo = ref(window.Echo);
    const $user = new User();
    if (window.Echo && $user.id) {
        $echo.value = window.Echo.private(`App.Models.User.${$user.id}`);

        $echo.value.listen("TestEvent", (evt: any) => console.log("TestEvent", evt));

        if (events.length) {
            events.forEach((event) => {
                $echo.value.listen(event.event, event.callback);
            });
            onUnmounted(() => {
                events.forEach((event) => {
                    $echo.value.stopListening(event.event, event.callback);
                });
            });
        }
        return $echo.value;
    }
    return $echo.value;
};
